// Types
import { SET_SIGNALS, ADD_SHOWN_SIGNAL, CLEAR_SIGNALS } from 'store/actions/Signals/types'

export const setSignals = (payload) => ({
  type: SET_SIGNALS,
  payload,
})

export const addShownSignal = (payload) => ({
  type: ADD_SHOWN_SIGNAL,
  payload,
})

export const clearSignals = () => ({
  type: CLEAR_SIGNALS,
})
